import { useCallback } from "react"
import { Block, Button, useStyletron } from "@mezo-org/mezo-clay"

import {
  selectRepayLoanAmount,
  selectRepayStrategy,
  setRepayLoanAmount,
  useDappDispatch,
  useDappSelector,
} from "#/redux-state"
import { useRepayBorrowAmount } from "#/shared/hooks"
import { BorrowRepayStrategy } from "#/shared/types"
import { bigIntToFloat } from "#/shared/utils"
import { ComponentStepProps } from "#/ui/Modal"

import { BorrowProgress } from "../components"

import RepayActionStrategy from "./RepayActionStrategy"
import RepayAmount from "./RepayAmount"

export default function RepayAction({ onClickContinue }: ComponentStepProps) {
  const [css, theme] = useStyletron()
  const dispatch = useDappDispatch()

  const repayStrategy = useDappSelector(selectRepayStrategy)
  const repaymentAmount = useDappSelector(selectRepayLoanAmount)

  const { isRepayAmountValid, fullRepaymentAmount } = useRepayBorrowAmount()

  const handleContinue = useCallback(() => {
    if (repayStrategy === BorrowRepayStrategy.TOTAL) {
      dispatch(setRepayLoanAmount(bigIntToFloat(fullRepaymentAmount)))
    }
    onClickContinue()
  }, [dispatch, fullRepaymentAmount, onClickContinue, repayStrategy])

  return (
    <Block flex={1}>
      <BorrowProgress step={1} stepsCount={4} />
      <Block
        className={css({
          paddingInline: theme.sizing.scale800,
          height: "calc(100% - 44px)",
          display: "flex",
          flexDirection: "column",
        })}
      >
        <Block
          className={css({
            display: "flex",
            flex: 1,
            flexDirection: "column",
            justifyContent: "space-between",
            gap: theme.sizing.scale700,
          })}
        >
          <RepayActionStrategy />
          {repayStrategy === BorrowRepayStrategy.PARTIAL && <RepayAmount />}
        </Block>
        <Button
          data-attr="repay_loan-step_2"
          size="large"
          disabled={
            !repayStrategy ||
            (repayStrategy === BorrowRepayStrategy.PARTIAL &&
              (!repaymentAmount || !isRepayAmountValid))
          }
          onClick={handleContinue}
        >
          Continue
        </Button>
      </Block>
    </Block>
  )
}
